import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sms-message-details',
  templateUrl: './sms-message-details.component.html',
  styleUrls: ['./sms-message-details.component.scss']
})
export class SmsMessageDetailsComponent implements OnInit {

  @Input() currentObject: any;
  @Output() afterSubmitEvent = new EventEmitter<object>();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close();
    this.afterSubmitEvent.emit();
  }
}
